// Avatar de jugador: su foto si la tiene; si no (de momento ningún jugador guarda foto), la silueta
// genérica del original. El nombre va sobre la parte baja, con un límite de longitud para que nunca
// ocupe media pantalla.
const MAX_NOMBRE = 13;

export function abreviarNombre(nombre: string): string {
  const partes = nombre.trim().split(/\s+/).filter(Boolean);
  if (!partes.length) return "";
  // "Alicia Gómez" → "Alicia G."; si la segunda palabra no es un apellido ("Jugador 1") se deja tal cual.
  const hayApellido = partes.length > 1 && /^\p{L}/u.test(partes[1]);
  const corto = hayApellido ? `${partes[0]} ${partes[1][0].toUpperCase()}.` : partes.join(" ");
  return corto.length > MAX_NOMBRE ? `${corto.slice(0, MAX_NOMBRE - 1)}…` : corto;
}

export function Silueta() {
  return (
    <svg viewBox="0 0 100 100" aria-hidden="true">
      <rect width="100" height="100" fill="#fff" />
      <path d="M21 73c0-14.5 12.6-21.5 29-21.5S79 58.5 79 73z" fill="#021221" />
      <circle cx="50" cy="35.5" r="14.5" fill="#021221" stroke="#fff" strokeWidth="2.2" />
    </svg>
  );
}

export function Avatar({ nombre, fotoUrl }: { nombre: string; fotoUrl: string | null }) {
  return (
    <div className="mc-avatar">
      {fotoUrl ? <img src={fotoUrl} alt="" /> : <Silueta />}
      <div className="mc-avatar-nombre" title={nombre}>
        {abreviarNombre(nombre)}
      </div>
    </div>
  );
}
